var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c(
        "ul",
        { class: _vm.prefixClass },
        _vm._l(_vm.data, function(submenu, index) {
          return _c(
            "li",
            {
              key: index,
              on: {
                click: function($event) {
                  _vm.switchNav(submenu.routeName)
                }
              }
            },
            [
              submenu.icon ? _c("i", { class: submenu.icon }) : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(submenu.title))])
            ]
          )
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-692a76a8", { render: render, staticRenderFns: staticRenderFns })
  }
}